<span class="wrapper" [class.with-chip-text]="chipText" [class.type-warning]="icon === 'warning'" (mouseover)="onMouseOver()" (mouseleave)="onMouseLeave()">
	<span>
		<i class="fa fa-info-circle" *ngIf="!icon || icon==='info'"></i>
		<i class="fa fa-question-circle" *ngIf="icon==='help'"></i>
		<i [ngClass]="'fa fa-' + icon" *ngIf="icon!=='help' && icon!=='info'"></i>
	</span>
	
	<bb-tooltip #tooltip [contents]="contents" [link]="link" [targetElement]="element" [changeDetector]="changeDetector"></bb-tooltip>
	<span class="chip-text" *ngIf="chipText">
		{{ chipText }}
	</span>
</span>
